import axios from "axios";
import { loginHeader } from "./loginHeader";

const API = "https://api.deafassistant.com/stream/";
const DEFAULT_LOGO = "https://cdn-icons-png.flaticon.com/512/2395/2395089.png";
const DEFAULT_COLOR = "#888888";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Post = (url: string, data: any, config?: any) => Promise<unknown>;

export interface StreamEdit {
  oldName: string;
  name: string;
  logoUrl: string;
  bannerColor: string;
  uid: string;
}

/**
 * Applies an edit (name, logo or colour) to a stream's page with stream/RenameStream, which regenerates the page in
 * place and moves the saved transcripts, questions and contacts to the new name. It must never delete the stream first:
 * that erases the stream's history and questions. If the page does not exist yet (nothing to rename) it is created instead.
 */
export async function applyStreamEdit(edit: StreamEdit, post: Post = axios.post, header: () => Promise<object> = loginHeader): Promise<void> {
  const logoUrl = edit.logoUrl === "" ? DEFAULT_LOGO : edit.logoUrl;
  const bannerColor = edit.bannerColor === "" ? DEFAULT_COLOR : edit.bannerColor;
  try {
    await post(API + "RenameStream", { oldName: edit.oldName.toLowerCase(), name: edit.name.toLowerCase(), logoUrl, bannerColor, uid: edit.uid }, await header());
  } catch (error: any) {
    const message = typeof error?.response?.data === "string" ? error.response.data : "";
    if (error?.response?.status === 400 && message.includes("does not exist")) {
      await post(API + "CreateStreamWithStyle", { name: edit.name.toLowerCase(), logoUrl, bannerColor });
      return;
    }
    throw error;
  }
}
